import { Breadcrumb, Button, CheckboxProps, Input } from "antd";
import { fabrics } from "../scripts/fabrics";
import { useEffect, useState } from "react";
import TextArea from "antd/es/input/TextArea";
import { PlusOutlined } from "@ant-design/icons";
import Experts from "./Experts";
import CompanyInfo from "../components/company-info/company-info";
import NumberOfMentions from "../components/NumberOfMentions";
import BanksInfo from "../components/banks-info/banks-info";
import { StructureGraph } from "../components/StructureGraph/graphComponent";
import TonalStatistic from "../components/TonalStatistic";
import PostsThread from "../components/PostsThread";
import BankBlocks from "../components/BankBlocks";
import RequestsTable from "../components/RequestsTable";
import Competitors from "../components/Competitors";
import { PieChart } from "../components/Charts/PieChart";
import SingleGraph from "../components/SingleGraph";
import ProductsSlider from "../components/ProductsSliders";
import ProductsSliderComp from "../components/ProductsSliderComp";
import ShareofVoices from "../components/ShareOfVoices";
import ActualNews from "../components/ActualNews";
import PostsList from "../components/PostsList";

const PersonalPage = () => {
  const [current, setCurrent] = useState<number>(0);
  const [title, setTitle] = useState<string>(fabrics[0]?.title);
  const [description, setDescription] = useState<string>(fabrics[0]?.title);
  const [inn, setInn] = useState<number>(fabrics[0]?.inn);
  const [tonal, setTonal] = useState();
  let type = localStorage.getItem("usertype");

  useEffect(() => {
    setTitle(fabrics[current]?.title);
    setDescription(fabrics[current]?.description);
    setInn(fabrics[current]?.inn);
  }, [current]);

  const handleInputTitle = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    setTitle(event.target.value);
  };
  const handleInputINN = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setInn(+event.target.value);
  };

  const handleInputDesc = (event: any): void => {
    setDescription(event.target.value);
  };

  const onChange: CheckboxProps["onChange"] = (e) => {
    console.log(`checked = ${e.target.checked}`);
  };

  return (
    <div className="App">
      <Breadcrumb
        items={[
          {
            title: "Промышленность",
          },
          {
            title: "Предприятие",
          },
        ]}
      />
      {/*<div className="btn-group">
        fabrics?.map((competitor: any, id) => (
          <Button
            key={id}
            type={current == id ? "primary" : "default"}
            onClick={() => {
              setCurrent(id);
            }}
          >
            {competitor?.title}
          </Button>
          ))<Button
          type={current == 10000000 ? "primary" : "default"}
          onClick={() => {
            setCurrent(10000000);
          }}
        >
          <PlusOutlined /> Добавить предприятие
        </Button>
      </div>*/}
      {current == 10000000 ? (
        <div className="tabs-group">
          <p>ИНН</p>
          <Input
            type="number"
            placeholder="Введите ИНН"
            value={inn}
            name="INN"
            onChange={handleInputINN}
          />
          <p>Название предприятия</p>
          <Input
            type="text"
            placeholder="Введите название предприятия"
            value={title}
            name="title"
            onChange={handleInputTitle}
          />
          <p>Описание</p>
          <TextArea
            placeholder="Введите описание"
            value={description}
            name="description"
            rows={4}
            onChange={handleInputDesc}
          />
          <Button type="primary">Сохранить</Button>
          <p></p>
          {/*<Button onClick={() => setModalDepOpen(true)}><PlusOutlined /> Добавить отдел</Button>
                {" "}
                <Button onClick={() => setModalOpen(true)}><PlusOutlined /> Добавить сотрудника организации</Button>
                */}
        </div>
      ) : (
        <div>
          <CompanyInfo current={+current} />
          <div className="grid25 light-block">
            <RequestsTable />
            {/*<Competitors />*/}
            <SingleGraph />
          </div>
          <BankBlocks />
          <div className="grid2">
            <div>
              <NumberOfMentions />
              <ShareofVoices />
              <ActualNews/>
            </div>
            <div>
              <ProductsSlider />
              <ProductsSliderComp />
              <PostsList />
            </div>
          </div>
          <BanksInfo />
          {type == "admin" && (
            <>
              <Experts />
              <StructureGraph />
            </>
          )}
        </div>
      )}
    </div>
  );
};
export default PersonalPage;
